import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ERulerActionType } from './types';

export const disableRuler = actionGenerator<ERulerActionType.RulerDisabled>(ERulerActionType.RulerDisabled);
